import ApiRoutes from "../config/ApiRoutes"
import { checkAuthentication, getDateAsYYYYMMDDString } from "../config/Util"

export const OrderService = {
    getMealsForDay: function(date) {
        return new Promise((resolve, reject) => {

            let formData = new FormData()

            formData.append("datum", getDateAsYYYYMMDDString(date))

            fetch(ApiRoutes.GET_DAY_MEALS, {
                method: "POST",
                body: formData,
                credentials: "include"
            })
            .then(response => {
                if (response.status !== 200) {
                    reject(response.statusText)
                } else {
                    return response.json()
                }
            })
            .then(checkAuthentication)
            .then(data => resolve(data))
            .catch(error => reject(error))

        })
    },

    getStockStatus: function(date) {
        return new Promise((resolve, reject) => {

            let formData = new FormData()

            formData.append("datum", getDateAsYYYYMMDDString(date))

            fetch(ApiRoutes.GET_STOCK_STATUS, {
                method: "POST",
                body: formData,
                credentials: "include"
            })
            .then(response => {
                if (response.status !== 200) {
                    reject(response.statusText)
                } else {
                    return response.json()
                }
            })
            .then(checkAuthentication)
            .then(data => resolve(data))
            .catch(error => reject(error))

        })
    },

    getMyOrders: function(date) {
        return new Promise((resolve, reject) => {

            let formData = new FormData()

            formData.append("datum", getDateAsYYYYMMDDString(date))

            fetch(ApiRoutes.GET_MY_ORDERS, {
                method: "POST",
                body: formData,
                credentials: "include"
            })
            .then(response => {
                if (response.status !== 200) {
                    reject(response.statusText)
                } else {
                    return response.json()
                }
            })
            .then(checkAuthentication)
            .then(data => resolve(data))
            .catch(error => reject(error))

        })
    },

    deleteOrder: function(orderId) {
        return new Promise((resolve, reject) => {

            let formData = new FormData()

            formData.append("idpaketa", orderId)

            fetch(ApiRoutes.DELETE_ORDER, {
                method: "POST",
                body: formData,
                credentials: "include"
            })
            .then(response => {
                if (response.status !== 200) {
                    reject(response.statusText)
                } else {
                    return response.text()
                }
            })
            .then(checkAuthentication)
            .then(data => resolve(data))
            .catch(error => reject(error))

        })
    },

    makeNewOrder: function(cart, date) {
        return new Promise((resolve, reject) => {

            let formData = new FormData()

            formData.append("datum", getDateAsYYYYMMDDString(date))
            formData.append("korpa", JSON.stringify(cart))

            fetch(ApiRoutes.MAKE_NEW_ORDER, {
                method: "POST",
                body: formData,
                credentials: "include"
            })
            .then(response => {
                if (response.status !== 200) {
                    reject(response.statusText)
                } else {
                    return response.text()
                }
            })
            .then(checkAuthentication)
            .then(data => resolve(data))
            .catch(error => reject(error))

        })
    },

    saveEditedOrder: function(orderId, cart) {
        return new Promise((resolve, reject) => {

            let formData = new FormData()

            formData.append("idpak", orderId)
            formData.append("korpa", JSON.stringify(cart))

            fetch(ApiRoutes.SAVE_EDITED_ORDER, {
                method: "POST",
                body: formData,
                credentials: "include"
            })
            .then(response => {
                if (response.status !== 200) {
                    reject(response.statusText)
                } else {
                    return response.text()
                }
            })
            .then(checkAuthentication)
            .then(data => resolve(data))
            .catch(error => reject(error))

        })
    },

    getOrderInfo: function(orderId) {
        return new Promise((resolve, reject) => {

            let formData = new FormData()

            formData.append("idpak", orderId)

            fetch(ApiRoutes.GET_ORDER_INFO, {
                method: "POST",
                body: formData,
                credentials: "include"
            })
            .then(response => {
                if (response.status !== 200) {
                    reject(response.statusText)
                } else {
                    return response.json()
                }
            })
            .then(checkAuthentication)
            .then(data => {
                data.shift()
                resolve(data)
            })
            .catch(error => reject(error))

        })
    },

    getOrdersHistory: function() {
        return new Promise((resolve, reject) => {
            fetch(ApiRoutes.GET_ORDERS_HISTORY, {
                method: "GET",
                credentials: "include"
            })
            .then(response => {
                if (response.status !== 200) {
                    reject(response.statusText)
                } else {
                    return response.json()
                }
            })
            .then(checkAuthentication)
            .then(data => resolve(data))
            .catch(error => reject(error))

        })
    },

    setOrderInProgress: function(date) {
        return new Promise((resolve, reject) => {

            let formData = new FormData()

            formData.append("datum", getDateAsYYYYMMDDString(date))

            fetch(ApiRoutes.SET_ORDER_IN_PROGRESS, {
                method: "POST",
                body: formData,
                credentials: "include"
            })
            .then(response => {
                if (response.status !== 200) {
                    reject(response.statusText)
                } else {
                    return response.text()
                }
            })
            .then(checkAuthentication)
            .then(data => resolve(data))
            .catch(error => reject(error))

        })
    },

    removeOrderInProgress: function() {
        return new Promise((resolve, reject) => {

            fetch(ApiRoutes.REMOVE_ORDER_IN_PROGRESS, {
                method: "GET",
                credentials: "include"
            })
            .then(response => {
                if (response.status !== 200) {
                    reject(response.statusText)
                } else {
                    return response.text()
                }
            })
            .then(checkAuthentication)
            .then(data => resolve(data))
            .catch(error => reject(error))

        })
    }

}
